import { render, staticRenderFns } from "./childComponents.vue?vue&type=template&id=6c0d0617"
import script from "./childComponents.vue?vue&type=script&lang=js"
export * from "./childComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports